import {
  type AxiosInstance,
  type AxiosResponse,
  HttpStatusCode,
  isAxiosError,
} from "axios";
import {
  type IdentificationNamePutRequest,
  type IdentificationNamePutResponse,
} from "@/features/acquireBookStatus/types";
import { SendToTrackingService } from "@/api/handlers/errors";

/**
 * 識別名を更新するAPIを実行する。
 * @param {AxiosInstance} apiClient
 * @param {IdentificationNamePutRequest} requests
 */
export const PutIdentificationNameAPI = async (
  apiClient: AxiosInstance,
  pictureRequestId: number,
  requests: IdentificationNamePutRequest
): Promise<IdentificationNamePutResponse> => {
  const url = `/picture-request/${pictureRequestId}`;

  try {
    const response = await apiClient.put<IdentificationNamePutResponse>(
      url,
      requests
    );

    return response.data;
  } catch (error) {
    if (
      isAxiosError<AxiosResponse>(error) &&
      (error.response?.status ?? HttpStatusCode.InternalServerError) >=
        HttpStatusCode.InternalServerError
    ) {
      SendToTrackingService(error);
    }
    throw error;
  }
};
